module.exports = __webpack_public_path__ + "static/media/Orpyx-SI-Logo-Knockout.3975bbe9.svg";